import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { partnerGroups } from "../lib/data";
import SectionHeading from "./SectionHeading";

const ClientsPartners = () => {
  const { t, lang } = useLanguage();

  return (
    <section className="py-24 md:py-32" data-testid="clients-partners-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <SectionHeading label={t.clientsPartners.label} title={t.clientsPartners.heading} sub={t.clientsPartners.sub} center />

        <div className="mt-16 space-y-10">
          {partnerGroups.map((group, gi) => (
            <motion.div
              key={group.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: gi * 0.08 }}
              data-testid={`partner-group-${group.id}`}
            >
              <div className="flex items-center gap-4 mb-5">
                <span className="section-label !mb-0">{group[lang]}</span>
                <span className="flex-1 h-px bg-white/8" />
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-white/5 border border-white/5">
                {group.logos.map((logo) => (
                  <div
                    key={logo}
                    className="bg-[#11203A] h-24 grid place-items-center text-slate-300 hover:text-[#D4AF37] hover:bg-[#1A2C47] transition-colors duration-300"
                    data-testid={`partner-logo-${logo.replace(/\s/g, "-")}`}
                  >
                    <span className="font-heading font-bold text-base md:text-lg tracking-wide text-center px-2">{logo}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsPartners;
